// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StudentManagement from './components/StudentManagement';
import StudentForm from './components/StudentForm';
import Layout from './components/Layout';
import Login from './components/Login';
import Register from './components/Register';
import YearList from './components/YearList'; // 新增导入
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DatabasePage from './pages/admin/DatabasePage';
import UsersPage from './pages/admin/UsersPage';

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <StudentManagement />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/students/new" element={
            <ProtectedRoute>
              <Layout>
                <StudentForm />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/students/:id/edit" element={
            <ProtectedRoute>
              <Layout>
                <StudentForm />
              </Layout>
            </ProtectedRoute>
          } />

          {/* 新增年度管理路由 */}
          <Route path="/years" element={
            <ProtectedRoute>
              <Layout>
                <YearList />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/admin/users" element={
            <ProtectedRoute>
              <Layout>
                <UsersPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/admin/database" element={
            <ProtectedRoute>
              <Layout>
                <DatabasePage />
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;